function isLockUnavailable(error: unknown) {
  return error instanceof DOMException
    && (error.name === "SecurityError" || error.name === "NotSupportedError")
}

export async function withLocalPrintTabLock(shopId: string, run: () => Promise<void>) {
  let callbackEntered = false
  try {
    const locks = navigator.locks
    if (typeof locks?.request !== "function") {
      callbackEntered = true
      await run()
      return
    }
    await locks.request(`teashop:auto-print:v1:shop:${shopId}`, { mode: "exclusive", ifAvailable: true }, async (lock) => {
      callbackEntered = true
      if (lock) await run()
    })
  } catch (error) {
    // 只有准入前确认能力不可用才降级；锁忙、取消或已执行后的失败都不能重跑业务。
    if (callbackEntered || !isLockUnavailable(error)) throw error
    await run()
  }
}
